import { GsbUser } from './gsb-user.model';

export enum BackupStatus {
    Created = 0,
    Started = 1,
    Completed = 2,
    Restored = 4
}

export class GsbBackup {
    _entDefName?: string;
    public id?: string;
    public code?: string;
    public title?: string;
    public isAuto?: boolean;
    public status?: BackupStatus;
    public createDate?: Date;
    public lastUpdateDate?: Date;
    public createdBy_id?: string;
    public lastUpdatedBy_id?: string;
    public createdBy?: GsbUser;
    public lastUpdatedBy?: GsbUser;

    constructor(obj?: Partial<GsbBackup>) {
        Object.assign(this, obj);
        this._entDefName = "GsbBackup";
    }
} 